/**
 * Bug Bow buy box behaviour.
 *
 * Responsibilities:
 *  - Keep the selected variant id, price and availability in sync.
 *  - Emit analytics events (dataLayer / GA4 / Shopify) via a thin wrapper.
 *  - Progressively enhance a plain <form action="/cart/add">; with JS disabled
 *    the form still posts to /cart/add and Shopify shows the cart.
 */
(function () {
  function track(event, payload) {
    payload = payload || {};
    try {
      window.bugBowEvents = window.bugBowEvents || [];
      window.bugBowEvents.push({ event: event, payload: payload, ts: Date.now() });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload));
      if (typeof window.gtag === 'function') window.gtag('event', event, payload);
    } catch (e) {
      /* analytics must never break the store */
    }
  }
  window.bugBowTrack = track;

  class BugBowBuybox extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-bb-order-form]');
      this.submit = this.querySelector('[data-bb-submit]');
      this.variantSelect = this.querySelector('[data-bb-variant-select]');
      this.idInput = this.querySelector('[data-bb-id]');
      this.priceOutput = this.querySelector('[data-bb-price]');
      this.priceMirror = this.querySelector('[data-bb-price-mirror]');
      this.errorEl = this.querySelector('[data-bb-order-error]');

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => this.onVariantChange());
      }
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      this.querySelectorAll('[data-bb-cta]').forEach((btn) =>
        btn.addEventListener('click', () =>
          track('cta_order_click', { source: btn.getAttribute('data-bb-cta') })
        )
      );
    }

    onVariantChange() {
      const opt = this.variantSelect.selectedOptions[0];
      if (!opt) return;
      const price = opt.getAttribute('data-price');
      if (price && this.priceOutput) this.priceOutput.textContent = price;
      if (price && this.priceMirror) this.priceMirror.textContent = price;
      const available = opt.getAttribute('data-available') === 'true';
      if (this.submit) {
        this.submit.disabled = !available;
        const t = this.submit.querySelector('[data-bb-submit-text]');
        if (t)
          t.textContent = available
            ? this.submit.getAttribute('data-label-available')
            : this.submit.getAttribute('data-label-soldout');
      }
      track('variant_change', { variant_id: this.variantSelect.value });
    }

    onSubmit(e) {
      const value = this.priceOutput
        ? parseFloat((this.priceOutput.textContent || '').replace(/[^0-9.]/g, ''))
        : undefined;
      track('add_to_cart', { variant_id: this.idInput ? this.idInput.value : null, value: value });

      // Progressive enhancement: use fetch + Dawn cart drawer if available.
      const drawer = document.querySelector('cart-drawer');
      if (window.fetch && drawer && typeof drawer.renderContents === 'function') {
        e.preventDefault();
        const config = { method: 'POST', headers: { Accept: 'application/javascript' } };
        const formData = new FormData(this.form);
        const sections = drawer
          .getSectionsToRender()
          .map((s) => s.id)
          .join(',');
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
        fetch(window.Shopify.routes.root + 'cart/add', config)
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              if (this.errorEl) {
                this.errorEl.hidden = false;
                this.errorEl.textContent = response.description || response.message;
                this.errorEl.focus();
              }
              return;
            }
            if (this.errorEl) this.errorEl.hidden = true;
            track('begin_checkout', { value: value });
            drawer.classList.remove('is-empty');
            var drawerInner = drawer.querySelector('.drawer__inner');
            if (drawerInner) drawerInner.classList.remove('is-empty');
            var drawerItems = drawer.querySelector('cart-drawer-items');
            if (drawerItems) drawerItems.classList.remove('is-empty');
            drawer.renderContents(response);
            if (typeof drawer.open === 'function') drawer.open();
          })
          .catch(() => {
            this.form.submit();
          });
      }
      // else: native submit to /cart/add proceeds (guest-checkout friendly).
    }
  }

  if (!customElements.get('bug-bow-buybox')) {
    customElements.define('bug-bow-buybox', BugBowBuybox);
  }
})();
